import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dispatchCount',
    standalone: false
})
export class DispatchCountPipe implements PipeTransform {

    transform(
        dispatches: any[],
        isPmGrouped: boolean
    ): number {
        if (!Array.isArray(dispatches)) return 0;

        return isPmGrouped
            ? dispatches.reduce((sum, g) => sum + (g.items?.length ?? 0), 0)
            : dispatches.length;
    }
}
